import dotProp from 'dot-prop-immutable'
import clone from 'lodash/clone'
import {
  ALLOW_TO_RESIZE,
  CHANGE_BORDER_COLOR,
  CHANGE_BORDER_TYPE,
  COPY_FRAME,
  DESELECT_FRAME,
  DISALLOW_TO_RESIZE,
  FINISH_RESIZING_FRAME,
  INSERT_FRAME,
  INSERT_SET,
  LOAD_PROJECT,
  MOVE_FRAME,
  MOVE_SET,
  REMOVE_FRAME,
  REMOVE_SET,
  RENAME_PROJECT,
  RESIZE_FRAME,
  ROTATE_FRAME,
  SELECT_FRAME,
  SELECT_PHOTO,
  SELECT_SET,
  SET_BG_CALIBRATION,
  SPLIT_SET,
  SWITCH_BACKGROUND,
  CREATED_PROJECT,
  SAVE_PROJECT,
  START_CROPPING,
  REFRESH_CROP_VALUES_PICTURE,
  REFRESH_CROP_VALUES_BACKGROUND,
  MERGE_SET, UPDATE_WALLPAPER, UPDATE_WALLPAPER_DIM, MOVE_FRAME_SIMPLE, MOVE_SET_SIMPLE, REMOVE_SETS
} from "../constants/projectActions";
import perMeterCalc from '../utils/perMeterCalc'
import { ACCEPT_GAUGE, REFRESH_GAUGE } from "../constants/wallpapersActions";

const initialState = {
  id: '',
  name: '',
  order: '',
  background: {
    src: '',
    scale: 1,
    index: 0,
    perMeter: 1000,
    croped: false,
    calibrated: true,
    crop: {
      width: 100,
      height: 100,
      x: 0,
      y: 0,
    },
  },
  pictures: [],
  sets: [],
  selectedIndex: -1,
  selected: [],
  selectedObject: '',
  temporarySize: {
    width: 0,
    height: 0,
  },
  allowToResize: false,
  allowToCrop: false,
  isSaving: false,
}

let flag = false

export default (state = initialState, action) => {
  switch (action.type) {
    case SWITCH_BACKGROUND:
      state = dotProp.set(state, 'background.src', action.src)
      state = dotProp.set(state, 'background.scale', action.scale)
      state = dotProp.set(state, 'background.index', action.index)
      state = dotProp.set(state, 'background.crop', { x: 0, y: 0, width: 0, height: 0, })

      if(action.rest && !action.rest.isCustom){
        state = dotProp.set(state, 'background.calibrated', true)
        state = dotProp.set(state, 'background.croped', false)
        state = dotProp.set(state, 'background.perMeter', action.perMeter/(1920/dotProp.get(state, 'dim.height', 1500)))
        state = dotProp.set(state, 'background.crop', { x: 0, y: 0, width: 100, height: 100, ch: dotProp.get(state, 'dim.height', 1350), cw: dotProp.get(state, 'dim.width', 900), aspect: 1.5 })
      }

      if(action.rest && action.rest.first){
        state = dotProp.set(state, 'background.first', true)
      }

      return state
    case INSERT_FRAME:
      return dotProp.set(state, `pictures.${state.pictures.length}`, {
        width: action.width,
        height: action.height,
        tmpWidth: perMeterCalc(action.width, state.background.perMeter),
        tmpHeight: perMeterCalc(action.height, state.background.perMeter),
        position: { x: action.positionX || 0, y: action.positionY || 0 },
        borderColor: '',
        borderType: 'noframe',
        borderWidth: 0,
      })
    case REMOVE_FRAME:
      state = dotProp.set(state, 'selectedIndex', -1)
      state = dotProp.set(state, 'selectedObject', '')
      state = dotProp.set(state, 'temporaryIndex', { width: 0, height: 0 })
      state = dotProp.delete(state, `pictures.${action.index}`)

      return state
    case COPY_FRAME:
      const toCopy = clone(dotProp.get(state, `pictures.${action.index}`))
      const picturesLength = dotProp.get(state, `pictures`, []).length
      state = dotProp.set(state, 'selectedIndex', -1)
      state = dotProp.set(state, 'selected', [])
      state = dotProp.set(state, 'selectedObject', '')

      return dotProp.set(state, `pictures.${picturesLength}`, toCopy)
    case ROTATE_FRAME:
      const { width, height } = dotProp.get(state, `pictures.${action.index}`)
      state = dotProp.set(state, `pictures.${action.index}.width`, height)
      state = dotProp.set(state, `pictures.${action.index}.tmpWidth`, perMeterCalc(height, state.background.perMeter))
      state = dotProp.set(state, `pictures.${action.index}.height`, width)
      state = dotProp.set(state, `pictures.${action.index}.tmpHeight`, perMeterCalc(width, state.background.perMeter))
      state = dotProp.set(state, `pictures.${action.index}.crop`, {x: 0, y: 0, width: 0, height: 0})
      state = dotProp.set(state, `pictures.${action.index}.resized`, true)

      return state
    case 'SET_ALL_PICTURES':
      state = dotProp.set(state, 'selectedIndex', -1)
      state = dotProp.set(state, 'selectedObject', '')
      state = dotProp.set(state, 'temporaryIndex', { width: 0, height: 0 })
      return dotProp.set(state, 'pictures', action.pictures)
    case SET_BG_CALIBRATION:
      return dotProp.set(state, 'background.perMeter', action.perMeter)
    case MOVE_FRAME:

      let selectedDraggable = dotProp.get(state, 'selected', [])

      selectedDraggable.forEach(s => {
        state = dotProp.set(state, `${s.type=== 'frame'? 'pictures':'sets'}.${s.id}.position`, { x: dotProp.get(state, `${s.type=== 'frame'? 'pictures':'sets'}.${s.id}.position.x`)+action.x, y: dotProp.get(state, `${s.type=== 'frame'? 'pictures':'sets'}.${s.id}.position.y`)+action.y })
      })

      return state

    case MOVE_FRAME_SIMPLE:
      return dotProp.set(state, `pictures.${action.index}.position`, { x: action.x, y: action.y })

    case SELECT_FRAME:

      const selected = dotProp.get(state, 'selected', [])

      if(!flag){
        if(selected.map(s => s.id).indexOf(action.index) > -1){
          selected.splice(selected.map(s => s.id).indexOf(action.index), 1)
        } else {
          selected.push({type: 'frame', id: action.index})
        }
        flag = true
        setTimeout(() => {
          flag = false
        }, 100)
      }

      state = dotProp.set(state, 'selected', selected)
      state = dotProp.set(state, 'selectedIndex', action.index)
      state = dotProp.set(state, 'selectedObject', 'frame')

      return state
    case DESELECT_FRAME:
      state = dotProp.set(state, 'selectedIndex', -1)
      state = dotProp.set(state, 'selected', [])
      state = dotProp.set(state, 'selectedObject', '')

      return state
    case SELECT_PHOTO:
      state = dotProp.set(state, `pictures.${state.selectedIndex}.resized`, true)
      state = dotProp.set(state, `pictures.${action.index}.selectedImage`, action.src)
      return state
    case RESIZE_FRAME:
      state = dotProp.set(state, `pictures.${action.index}.tmpWidth`, action.width)
      state = dotProp.set(state, `pictures.${action.index}.tmpHeight`, action.height)
      state = dotProp.set(state, `pictures.${action.index}.resized`, action.resized)
      state = dotProp.set(state, `pictures.${action.index}.crop`, action.crop)

      return state
    case FINISH_RESIZING_FRAME:
      state = dotProp.set(state, `pictures.${action.index}.width`, action.width)
      state = dotProp.set(state, `pictures.${action.index}.height`, action.height)

      return state
    case INSERT_SET:
      return dotProp.set(state, `sets.${state.sets.length+100}`, {
        data: action.set,
        position: { x: action.positionX || 0, y: action.positionY || 0 },
      })
    case SELECT_SET:

      const selectedFrames = dotProp.get(state, 'selected', [])

      state = dotProp.set(state, `selected`, selectedFrames.map(s => s.id === action.index? {...s, type: 'set'}:s))
      state = dotProp.set(state, 'selectedIndex', action.index)
      state = dotProp.set(state, 'selectedObject', 'set')

      return state
    case SPLIT_SET:
      return {
        ...state,
        pictures: [...state.pictures, ...action.frames],
        selectedIndex: -1,
        selectedObject: '',
      }
    case MERGE_SET:
      state = dotProp.set(state, `sets.${action.set.index}`, action.set)
      return state
    case REMOVE_SET:
      state = dotProp.set(state, 'selectedIndex', -1)
      state = dotProp.set(state, 'selectedObject', '')
      state = dotProp.delete(state, `sets.${action.index}.data`)

      return state
    case MOVE_SET:
      return dotProp.set(state, `sets.${action.index}.position`, { x: action.x, y: action.y })

    case REMOVE_SETS:
      state = dotProp.set(state, 'selectedIndex', -1)
      state = dotProp.set(state, 'selectedObject', '')
      state = dotProp.set(state, `sets`, [])
      return state

    case MOVE_SET_SIMPLE:
      return dotProp.set(state, `sets.${action.index}.position`, { x: action.x, y: action.y })
    case LOAD_PROJECT:
      return { ...state, ...action.state }
    case DISALLOW_TO_RESIZE:
      return dotProp.set(state, 'allowToResize', false)
    case ALLOW_TO_RESIZE:
      return dotProp.set(state, 'allowToResize', true)
    case RENAME_PROJECT:
      return dotProp.set(state, 'name', action.name)
    case CHANGE_BORDER_COLOR:
      return dotProp.set(state, `pictures.${state.selectedIndex}.borderColor`, action.color)
    case CHANGE_BORDER_TYPE:
      state = dotProp.set(state, `pictures.${state.selectedIndex}.borderType`, action.borderType)
      state = dotProp.set(state, `pictures.${state.selectedIndex}.borderColor`, action.color)
      state = dotProp.set(state, `pictures.${state.selectedIndex}.borderWidth`, action.borderWidth)
      state = dotProp.set(state, `pictures.${state.selectedIndex}.preview`, action.label)

      return state
    case CREATED_PROJECT:
      return dotProp.set(state, 'id', action.id)
    case SAVE_PROJECT:
      return dotProp.set(state, 'isSaving', !dotProp.get(state, 'isSaving'))
    case START_CROPPING:
      return dotProp.set(state, 'allowToCrop', action.value)
    case REFRESH_CROP_VALUES_PICTURE:
      state = dotProp.set(state, `pictures.${state.selectedIndex}.crop`, action.crop)
      state = dotProp.set(state, `pictures.${state.selectedIndex}.resized`, false)

      return state
    case REFRESH_CROP_VALUES_BACKGROUND:
      state = dotProp.set(state, 'background.crop', {...action.crop, cw: state.dim.width, ch: state.dim.height})
      state = dotProp.set(state, 'background.calibrated', false)
      state = dotProp.set(state, 'background.croped', true)
      return state
    case REFRESH_GAUGE:
      state = dotProp.set(state, 'background.calibrated', true)
      state = dotProp.set(state, 'background.croped', false)
      return state
    case UPDATE_WALLPAPER_DIM:
      return dotProp.set(state, 'dim', {width: action.w, height: action.h})
    case ACCEPT_GAUGE:
      return dotProp.set(state, 'background.first', false)
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/project.js